const Support = () => {
    return (
        <div className="m-8 p-6 flex justify-center">
            <p><strong><a href="https://linktr.ee/gdscmakaut" target="_blank" className="hover:underline">GDSC MAKAUT LinkTree</a></strong></p>
        </div>
    );
};

export default Support;